/* eslint-disable no-nested-ternary */
/* eslint-disable */
import getSkeleton from './utils/getSkeleton';
import {
  getCurrency,
  getCountryCode,
  getOfferCode,
  requiredCompanyName,
  requiredPickupPointId
} from './utils/checker';

const getDeliveryType = offerCode => {
  if (requiredPickupPointId(offerCode)) {
    return 'pickupPoint';
  }
  return requiredCompanyName(offerCode) ? 'company' : 'residential';
};

/**
 * @function convertToCommandsArray
 * @description Convertir un fichier json en un fichier de commande
 * sympl
 * @param {Object[]} jsonFile - Fichier json
 * @returns {Object[]} Fichier de commande au format sympl
 */
const convertToCommandsArray = jsonFile => {
  const skeleton = getSkeleton(jsonFile);
  if (skeleton) {
    const symplFormatCommands = [];
    const unknowDeliveryOffer = [];

    let offerCodeHelper = offerCode => {
      let code = getOfferCode(offerCode);
      if (code) {
        return code.value;
      } else {
        unknowDeliveryOffer.findIndex(offer => offer.name === offerCode) === -1
          ? unknowDeliveryOffer.push({ name: offerCode, bindingValue: '' })
          : ''; // eslint-disable-line
        return null;
      }
    };

    jsonFile.forEach(command => {
      const index = symplFormatCommands.findIndex(
        symplFormatCommand =>
          symplFormatCommand.externalReference ===
          command[skeleton.externalReference].toString().trim()
      );
      const item = {
        externalReference: command[skeleton.productReference]
          ? command[skeleton.productReference].toString().trim()
          : null,
        ean13: command[skeleton.ean13]
          ? command[skeleton.ean13].toString().trim()
          : null,
        quantity: command[skeleton.quantity],
        description: command[skeleton.productDescription]
          ? command[skeleton.productDescription].toString().trim()
          : null,
        size: command[skeleton.size]
          ? command[skeleton.size].toString().trim()
          : null,
        color: command[skeleton.color]
          ? command[skeleton.color].toString().trim()
          : null,
        sellingPriceValue: command[skeleton.unitValue]
          ? command[skeleton.unitValue].toString().trim()
          : null,
        sellingPriceCurrency: command[skeleton.currency]
          ? command[skeleton.currency].toString().trim()
          : 'EUR'
      };

      const customsDeclarations = {
        currency: command[skeleton.currency]
          ? command[skeleton.currency].toString().trim()
          : 'EUR',
        declaredValue: command[skeleton.unitValue]
          ? command[skeleton.unitValue].toString().trim()
          : null,
        objectType: command[skeleton.productDescription]
          ? command[skeleton.productDescription].toString().trim()
          : null,
        quantity: command[skeleton.quantity]
          ? command[skeleton.quantity].toString().trim()
          : null
      };

      if (index !== -1) {
        symplFormatCommands[index].items.push(item);
        symplFormatCommands[index].customsDeclarations.push(
          customsDeclarations
        );
      } else {
        symplFormatCommands.push({
          pickupPoint: {
            id: command[skeleton.pickupPoint]
          },
          externalReference: command[skeleton.externalReference]
            ? command[skeleton.externalReference].toString().trim()
            : null,
          insuranceAmount: command[skeleton.insuranceAmount]
            ? +command[skeleton.insuranceAmount]
            : '300',
          deliveryType: getDeliveryType(command[skeleton.offerCode]),
          offerCode: offerCodeHelper(command[skeleton.offerCode]),
          initialOfferCode: command[skeleton.offerCode],
          shipmentCategory: 3,
          deliveryCarrierPickupPointId:
            command[skeleton.deliveryCarrierPickupPointId],
          deliveryCarrierPickupPointCarrierCode:
            command[skeleton.deliveryCarrierPickupPointCarrierCode],
          deliveryCarrierPickupPointName:
            command[skeleton.deliveryCarrierPickupPointName],
          deliveryCarrierPickupPointAddressStreet:
            command[skeleton.deliveryCarrierPickupPointAddressStreet],
          deliveryCarrierPickupPointAddressStreet2:
            command[skeleton.deliveryCarrierPickupPointAddressStreet2],
          deliveryCarrierPickupPointAddressPostalCode:
            command[skeleton.deliveryCarrierPickupPointAddressPostalCode],
          deliveryCarrierPickupPointAddressCity:
            command[skeleton.deliveryCarrierPickupPointAddressCity],
          deliveryCarrierPickupPointAddressCountryCode:
            command[skeleton.deliveryCarrierPickupPointAddressCountryCode],
          recipient: {
            email: command[skeleton.recipientEmail]
              ? command[skeleton.recipientEmail].toString().trim()
              : null,
            phoneNumber: command[skeleton.recipientPhoneNumber]
              ? command[skeleton.recipientPhoneNumber].toString().trim()
              : null,
            firstname: command[skeleton.firstname]
              ? command[skeleton.firstname].toString().trim()
              : command[skeleton.companyName]
              ? '.'
              : null,
            lastname: command[skeleton.lastname]
              ? command[skeleton.lastname].toString().trim()
              : command[skeleton.companyName]
              ? '.'
              : null,
            companyName: command[skeleton.companyName]
              ? command[skeleton.companyName].toString().trim()
              : null
          },
          recipientAddress: {
            street: command[skeleton.street]
              ? command[skeleton.street].toString().trim()
              : null,
            street2: command[skeleton.street2]
              ? command[skeleton.street2].toString().trim()
              : null,
            complement: command[skeleton.complement]
              ? command[skeleton.complement].toString().trim()
              : null,
            postalCode: command[skeleton.postalCode]
              ? command[skeleton.postalCode]
                  .toString()
                  .trim()
                  .replace(/^'/, '')
              : null,
            state: command[skeleton.state]
              ? command[skeleton.state].toString().trim()
              : null,
            city: command[skeleton.city]
              ? command[skeleton.city].toString().trim()
              : null,
            countryCode: getCountryCode(
              command[skeleton.countryCode]
                ? command[skeleton.countryCode].toString().trim()
                : ''
            )
          },
          appContext: {
            appCode: 'WEBAPP_V2',
            domain: ''
          },
          customsDeclarations: [
            {
              currency: getCurrency(
                command[skeleton.currency]
                  ? command[skeleton.currency].toString().trim()
                  : null
              ),
              declaredValue: command[skeleton.unitValue]
                ? command[skeleton.unitValue].toString().trim()
                : null,
              objectType: command[skeleton.productDescription]
                ? command[skeleton.productDescription].toString().trim()
                : null,
              quantity: command[skeleton.quantity]
            }
          ],
          items: [
            {
              sellingPriceCurrency: getCurrency(
                command[skeleton.currency]
                  ? command[skeleton.currency].toString().trim()
                  : null
              ),
              sellingPriceValue: command[skeleton.unitValue]
                ? command[skeleton.unitValue].toString().trim()
                : null,
              externalReference: command[skeleton.productReference]
                ? command[skeleton.productReference].toString().trim()
                : 1,
              ean13: command[skeleton.ean13]
                ? command[skeleton.ean13].toString().trim()
                : null,
              quantity: command[skeleton.quantity]
                ? command[skeleton.quantity]
                : 1,
              description: command[skeleton.productDescription]
                ? command[skeleton.productDescription].toString().trim()
                : null,
              size: command[skeleton.size]
                ? command[skeleton.size].toString().trim()
                : null,
              color: command[skeleton.color]
                ? command[skeleton.color].toString().trim()
                : null
            }
          ],
          errorsItem: [],
          warnings: []
        });
      }
    });
    return {
      symplFormatCommands,
      unknowDeliveryOffer
    };
  }
  return null;
};

export default convertToCommandsArray;
